package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import androidx.compose.runtime.Immutable
import dev.icerock.moko.resources.desc.StringDesc

/**
 * Content types that can be rendered inside a submenu.
 */
@Immutable
sealed interface SubMenuContent<TId : Enum<TId>> {

    /**
     * Radio submenu: a single-choice group (like Android XML checkableBehavior="single").
     */
    @Immutable
    data class RadioSubMenu<TId : Enum<TId>, TOption : Enum<*>>(
        val id: TId,
        val options: List<RadioOption<TOption>>,
        val selected: TOption,
        val onOptionSelected: (TOption) -> Unit,
    ) : SubMenuContent<TId>

    @Immutable
    data class RadioOption<TOption : Enum<*>>(
        val option: TOption,
        val title: StringDesc,
    )
}
